import script from "./bookingClass.vue?vue&type=script&setup=true&lang=js"
export * from "./bookingClass.vue?vue&type=script&setup=true&lang=js"

import "./bookingClass.vue?vue&type=style&index=0&id=957ba1f0&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-957ba1f0"]])

export default __exports__